import React from 'react';

import { useQuery } from 'react-query';

import { differenceInMinutes } from 'date-fns';

import { getProfile } from '@services/queries/profile';
import { getStudioInvites } from '@services/queries/studios';

import ProfileImage from '@assets/svg/avatar-placeholder.svg';
import UpIcon from '@assets/svg/table-up.svg';

import { InvitationsLoading } from './loading/Invitations.loading';
import { InvitationsError } from './error/Invitations.error';

import {
  Container,
  Head,
  Profile,
  Status,
  Table,
  User,
  MenuDiv,
  Divider,
  Text,
  MenuContainer,
  Span,
  Wrapper,
} from './Invitations.styles';
import { InvitationsMenu } from './components/InvitationsMenu/InvitationsMenu';

const Invitations = () => {
  const { data, isLoading, isError } = useQuery('invites', async () => {
    const profile = await getProfile();
    const invites = await getStudioInvites(profile.userGroup.studioId);

    return invites;
  });

  if (isLoading) {
    return <InvitationsLoading />;
  }

  if (isError || !data) {
    return <InvitationsError />;
  }

  return (
    <Container>
      <Table>
        <thead>
          <tr>
            <th>
              <Head className="email-header">Member</Head>
            </th>
            <th>
              <Head>Email</Head>
            </th>
            <th>
              <Head>Invited by</Head>
            </th>
            <th>
              <Head className="status-header">
                {' '}
                <Wrapper>
                  Role
                  <Span>
                    <img src={UpIcon} alt="" />
                  </Span>
                </Wrapper>
              </Head>
            </th>
            <th>
              <Head className="menu-header">
                <MenuDiv>M</MenuDiv>
              </Head>
            </th>
          </tr>
        </thead>

        <tbody>
          {data.map(item => {
            const status = (() => {
              if (item.accepted) {
                return 'accepted';
              }

              const daysToExpire = 7;
              const minutesToExpire = 60 * 24 * daysToExpire;

              const isExpired =
                differenceInMinutes(new Date(), item.createdAt) >=
                minutesToExpire;

              if (isExpired) {
                return 'expired';
              }

              return 'sent';
            })();

            return (
              <tr key={item.id}>
                <td>
                  <User>
                    <Profile
                      src={item.user?.picture || ProfileImage}
                      alt="profile"
                    />
                    <Divider width="8px" />
                    <Text status={status}>{status}</Text>
                  </User>
                </td>
                <td>
                  <Text status={status}>{item.email}</Text>
                </td>
                <td>
                  <Text className="role">{item.user && item.user?.name}</Text>
                </td>
                <td>
                  <Status>
                    <Text className="role">{item.role}</Text>
                  </Status>
                </td>
                <td>
                  <MenuContainer>
                    <InvitationsMenu data={item} />
                  </MenuContainer>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
};

export { Invitations };
